import type { SVGProps } from 'react'
const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="warning_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#warning_svg__a)">
      <path d="M.62 15.826 9 1.348l8.38 14.478zm2.83-1.639h11.1L9 4.626zm5.55-.7a.75.75 0 0 0 .548-.225.75.75 0 0 0 .224-.548.74.74 0 0 0-.224-.546.75.75 0 0 0-.548-.222.75.75 0 0 0-.548.223.74.74 0 0 0-.224.545q0 .324.224.548.225.225.548.225m-.75-2.237h1.5v-3.7h-1.5z" />
    </g>
  </svg>
)
export default SvgWarning
